export default __webpack_public_path__ + "static/media/p4.59bcc94b.jpg";